// TotalGeralMarkup.tsx
import React, { useRef, useEffect, useMemo, useContext } from 'react';
import globalMU from 'globalMU';
import { PermissoesContext } from '../TelaMarkupContainer';
import { TelaMarkupContext } from '../TelaMarkup';

const estiloTotalGeralMarkup = require('./totalGeralMarkup.module.scss').default;

export const TotalGeralMarkup = () => {
    const isMounted = useRef(true);
    const permissoes = useContext(PermissoesContext); // 484771
    const props = useContext(TelaMarkupContext);

    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    }, [])


    const markupMargemAnteriorValor = useMemo(() => {
        return props.substituirMarkupPorMargem
            ? globalMU.formatarValorNumerico(props.markup.Valores.TotalMargemLucroAnterior, 2, false)
            : globalMU.formatarValorNumerico(props.markup.Valores.MarkupAnterior, 2, false);
    }, [props.substituirMarkupPorMargem, props.markup.Valores.TotalMargemLucroAnterior, props.markup.Valores.MarkupAnterior]);

    const markupMargemZeroValor = useMemo(() => {
        return props.substituirMarkupPorMargem
            ? globalMU.formatarValorNumerico(props.markup.Valores.TotalMargemLucroMargemZero, 2, false)
            : globalMU.formatarValorNumerico(props.markup.Valores.MakupMargemZero, 2, false);
    }, [props.substituirMarkupPorMargem, props.markup.Valores.TotalMargemLucroMargemZero, props.markup.Valores.MakupMargemZero]);

    const markupDaUltimaPesquisaValor = useMemo(() =>
        globalMU.formatarValorNumerico(props.markup.Valores.MarkupUltimaPesquisa, 2, false),
        [props.markup.Valores.MarkupUltimaPesquisa]);

    const markupPrecoVendaUltimaPesquisaValor = useMemo(() =>
        globalMU.formatarValorNumerico(props.markup.Valores.MarkupPrecoVendaUltimaPesquisa, 2, false),
        [props.markup.Valores.MarkupPrecoVendaUltimaPesquisa]);

    const markupAtualValor = useMemo(() =>
        globalMU.formatarValorNumerico(props.markup.Valores.MarkupAtual, 2, false),
        [props.markup.Valores.MarkupAtual]);

    const margemLucroRealValor = useMemo(() =>
        globalMU.formatarValorNumerico(props.markup.Valores.MargemLucroReal, 2, false),
        [props.markup.Valores.MargemLucroReal]);

    const markupRealValor = useMemo(() =>
        globalMU.formatarValorNumerico(props.markup.Valores.MarkupReal, 2, false),
        [props.markup.Valores.MarkupReal]);

    const margemLucroValor = useMemo(() =>
        globalMU.formatarValorNumerico(props.markup.Valores.MargemLucro, 2, false),
        [props.markup.Valores.MargemLucro]);

    const precoVendaLiquida = useMemo(() =>
        globalMU.formatarValorNumerico(props.markup.Valores.PrecoVendaLiquida, props.mascaraPrecoVenda, true),
        [props.markup.Valores.PrecoVendaLiquida, props.mascaraPrecoVenda]);

    const custoUltimaPesquisa = useMemo(() =>
        globalMU.formatarValorNumerico(props.markup.Valores.CustoUltimaPesquisa, props.mascaraPrecoCompra, true),
        [props.markup.Valores.CustoUltimaPesquisa, props.mascaraPrecoCompra]);

    const custoOrcamento = useMemo(() =>
        globalMU.formatarValorNumerico(props.markup.Valores.CustoOrcamento, props.mascaraPrecoCompra, true),
        [props.markup.Valores.CustoOrcamento, props.mascaraPrecoCompra]);

    const markupBruto = useMemo(() =>
        globalMU.formatarValorNumerico(props.markup.Valores.MarkupBruto, 2, false),
        [props.markup.Valores.MarkupBruto]);

    const markupRealPorMl = useMemo(() =>
        globalMU.formatarValorNumerico(props.markup.Valores.MarkupRealPorMl, 2, false),
        [props.markup.Valores.MarkupRealPorMl]);

    const markupBrutoAVista = useMemo(() =>
        globalMU.formatarValorNumerico(props.markup.Valores.MarkupBrutoAVista, 2, false),
        [props.markup.Valores.MarkupBrutoAVista]);

    const contribuicao = useMemo(() =>
        globalMU.formatarValorNumerico(props.markup.Valores.Contribuicao, 2, false),
        [props.markup.Valores.Contribuicao]);

    const comissao = useMemo(() =>
        globalMU.formatarValorNumerico(props.markup.Valores.Comissao, 2, false),
        [props.markup.Valores.Comissao]);

    // Função auxiliar para verificar permissão (padrão false se não existir)
    const temPermissao = (nome: string) => permissoes[nome] === true;

    return (
        <>
            <h4 className={estiloTotalGeralMarkup.titulo}
                title='Veja parâmetros: &#013;-Permite interagir com a consulta de margem de lucro do orçamento&#013;-Trocar termo Markup por Margem de lucro&#013;-Substituir markup por margem de lucro&#013;&#013;Use segurança para ocultar totalizadores'
            >Total Geral</h4>
            <div className={estiloTotalGeralMarkup.form} id="TotalGeralMarkup_Totais">

                {/* Margem / Markup Anterior */}
                {props.substituirMarkupPorMargem
                    ? temPermissao("TOTALIZADOR_MARGEM_LUCRO_ANTERIOR") && (
                        <>
                            <label>Margem Lucro Anterior</label>
                            <div id="TotalGeralMarkup_MKAnterior_Valor_MargemLucroAnterior">{markupMargemAnteriorValor}</div>
                        </>
                    )
                    : temPermissao("TOTALIZADOR_MARKUP_ANTERIOR") && (
                        <>
                            <label>Markup Anterior</label>
                            <div id="TotalGeralMarkup_MKAnterior_Valor_MarkupAnterior">{markupMargemAnteriorValor}</div>
                        </>
                    )
                }

                {/* Margem / Markup Zero */}
                {props.substituirMarkupPorMargem
                    ? temPermissao("TOTALIZADOR_MARGEM_LUCRO_ZERO") && (
                        <>
                            <label>Margem Lucro 0</label>
                            <div id="TotalGeralMarkup_MKMargemZero_Valor_MargemLucroMargemZero">{markupMargemZeroValor}</div>
                        </>
                    )
                    : temPermissao("TOTALIZADOR_MARKUP_MARGEM_ZERO") && ( // 492101
                        <>
                            <label>Markup Margem 0</label>
                            <div id="TotalGeralMarkup_MKMargemZero_Valor_MarkupMargemZero">{markupMargemZeroValor}</div>
                        </>
                    )
                }

                {/* Custo da Última Pesquisa */}
                {temPermissao("TOTALIZADOR_CUSTO_DA_ULTIMA_PESQUISA") && (
                    <>
                        <label>Custo da Última Pesquisa</label>
                        <div>{custoUltimaPesquisa}</div>
                    </>
                )}

                {/* Markup da Última Pesquisa (só exibe se não substituir e não trocar termo) */}
                {!props.substituirMarkupPorMargem && !props.trocarTermoMarkupPorMargemDeLucro &&
                    temPermissao("TOTALIZADOR_MARKUP_DA_ULTIMA_PESQUISA") && (
                        <>
                            <label>Markup da Última Pesquisa</label>
                            <div id="TotalGeralMarkup_MKUltimaPesquisa_Valor_MarkupUltimaPesquisa">{markupDaUltimaPesquisaValor}</div>
                        </>
                    )}

                {/* MK Preço de Venda e Custo da Última Pesquisa */}
                {!props.substituirMarkupPorMargem && !props.trocarTermoMarkupPorMargemDeLucro &&
                    temPermissao("TOTALIZADOR_MK_PREÇO_DE_VENDA_E_CUSTO_DA_ULTIMA_PESQUISA_DE_PREÇO") && (
                        <>
                            <label>MK Preço de Venda e Custo da Última Pesquisa de Preço</label>
                            <div id="TotalGeralMarkup_MKPrecoVendaCustoUltimaPesquisa_Valor_MarkupPrecoVendaUltimaPesquisa">
                                {markupPrecoVendaUltimaPesquisaValor}
                            </div>
                        </>
                    )}

                {/* Margem / Markup Atual */}
                {props.substituirMarkupPorMargem
                    ? temPermissao("TOTALIZADOR_MARGEM_LUCRO_ATUAL") && (
                        <>
                            <label >Margem Lucro Atual</label>
                            <div id="TotalGeralMarkup_MargemLucroAtual_Valor_MarkupAtual">{markupAtualValor}</div>
                        </>
                    )
                    : temPermissao("TOTALIZADOR_MARKUP_ATUAL") && (
                        <>
                            <label>Markup Atual</label>
                            <div id="TotalGeralMarkup_MarkupAtual_ValorMarkupAtual">{markupAtualValor}</div>
                        </>
                    )}

                {/* Margem / Markup Real */}
                {props.substituirMarkupPorMargem
                    ? temPermissao("TOTALIZADOR_MARGEM_LUCRO_REAL") && (
                        <>
                            <label >Margem Lucro Real</label>
                            <div id="TotalGeralMarkup_MargemLucroReal_ValorMargemLucroReal">{margemLucroRealValor}</div>
                        </>
                    )
                    : temPermissao("TOTALIZADOR_MARKUP_REAL") && (
                        <>
                            <label >Markup Real</label>
                            <div id="TotalGeralMarkup_MarkupReal_ValorMarkupReal">{markupRealValor}</div>
                        </>
                    )}
                {!props.substituirMarkupPorMargem && temPermissao("TOTALIZADOR_MARGEM_OU_MARKUP_BRUTO") && // 490938
                    (
                        <>
                            <label >Markup Bruto</label>
                            <div id="TotalGeralMarkup_Markup_Bruto">{markupBruto}</div>
                        </>)
                }
                {/* Preço de Venda Líquido */}
                {temPermissao("TOTALIZADOR_PREÇO_DE_VENDA_LIQUIDO") && (
                    <>
                        <label>Preço de Venda Líquido</label>
                        <div>{precoVendaLiquida}</div>
                    </>
                )}

                {/* Custo do Orçamento */}
                {temPermissao("TOTALIZADOR_CUSTO_DO_ORÇAMENTO") && (
                    <>
                        <label>Custo do Orçamento</label>
                        <div>{custoOrcamento}</div>
                    </>
                )}

                {/* Margem Bruta / Markup Bruto (sempre exibido, pois não há permissão específica) */}
                {props.substituirMarkupPorMargem && temPermissao("TOTALIZADOR_MARGEM_OU_MARKUP_BRUTO") && (
                    <>
                        <label
                            id="TotalGeralMarkup_MarkupBrutoMargemBruta"

                        >{props.substituirMarkupPorMargem ? "Margem Bruta" : "Markup Bruto"}</label>
                        {!props.trocarTermoMarkupPorMargemDeLucro && (
                            <div id="TotalGeralMarkup_MarkupBrutoMargemBruta_ValorMarkupBruto">{markupBruto}</div>
                        )}
                        {props.trocarTermoMarkupPorMargemDeLucro && (
                            <div id="TotalGeralMarkup_MarkupBrutoMargemBruta_MarkupRealPorMl">{markupRealPorMl}</div>
                        )}
                    </>
                )}

                {/* Margem Lucro (só quando substituir é true) */}
                {props.substituirMarkupPorMargem && temPermissao("TOTALIZADOR_MARGEM_LUCRO") && (
                    <>
                        <label >Margem Lucro</label>
                        <div id="TotalGeralMarkup_MargemLucro_ValorMargemLucro">{margemLucroValor}</div>
                    </>
                )}

                {/* Totais exibidos apenas quando trocarTermo é true */}
                {props.trocarTermoMarkupPorMargemDeLucro && (
                    <>
                        {temPermissao("TOTALIZADOR_MARKUP_BRUTO_A_VISTA") && (
                            <>
                                <label title="Veja parâmetro: Trocar termo Markup por Margem de lucro">Markup Bruto À Vista</label>
                                <div id="TotalGeralMarkup_MarkupBrutoAVista">{markupBrutoAVista}</div>
                            </>
                        )}
                        {temPermissao("TOTALIZADOR_CONTRIBUIÇAO") && (
                            <>
                                <label >Contribuição</label>
                                <div id="TotalGeralMarkup_Contribuicao">{contribuicao}</div>
                            </>
                        )}
                        {temPermissao("TOTALIZADOR_COMISSAO") && (
                            <>
                                <label title="Veja parâmetro: Trocar termo Markup por Margem de lucro">Comissão</label>
                                <div id="TotalGeralMarkup_Comissao">{comissao}</div>
                            </>
                        )}
                    </>
                )}

                <section style={{ marginBottom: "100px" }} />
            </div>
        </>
    );
};